import React from 'react';
import { TenantStatus } from '../../types/admin';

/**
 * Visual status indicator for tenant status
 * Requirements: 10.4
 */
interface TenantStatusBadgeProps {
  status: TenantStatus;
}

const TenantStatusBadge: React.FC<TenantStatusBadgeProps> = ({ status }) => {
  const getStatusStyles = () => {
    switch (status) {
      case TenantStatus.ACTIVE:
        return 'bg-emerald-100 text-emerald-800 border-emerald-300';
      case TenantStatus.INACTIVE:
        return 'bg-gray-100 text-gray-800 border-gray-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusStyles()}`}>
      {status}
    </span>
  );
};

export default TenantStatusBadge;
